import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { Cargo } from '@/models/Cargo'

export default new CachedResourceStore<Cargo>(Cargo, {
	namespaced: true
})
